import React from "react";
import { Box, Zoom, Fab, useScrollTrigger } from "@material-ui/core";
import {
  WhatsApp as WhatsAppIcon
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import LinkEcco from "../Link";
import TagManager from 'react-gtm-module';

const useStyles = makeStyles( theme => ({
    root: {
        bottom: theme.spacing(3),
        [theme.breakpoints.up("xs")]: {
          position: "fixed",
          right: theme.spacing(3),
        },
        [theme.breakpoints.down("xs")]: {
          position: "fixed",
          right: theme.spacing(2),
          maxWidth: 340
        },
        zIndex: 1001
      },
    addButton: {
      backgroundColor: "#25d366",
      width: 77,
      height: 77,
      minHeight: 77,
      "&:hover": {
        backgroundColor: "#21bd5c"
      },
      [theme.breakpoints.down("xs")]: {
        width: 67,
        height: 67,
        minHeight: 67
      }
    },
    addButtonIcon: {
        marginTop: "4px",
        color: "white",
        fontSize: 43,
        [theme.breakpoints.down("xs")]: {
          fontSize: 36
        }
    }
  }));

const FloatingWhatsappButton = ({ home = false, isNotes = false, isSocios = false}) => {
  const classes = useStyles();
  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });

  return (
    <div>
      {isSocios ? (
          <Box className={classes.root}>
          
              <Fab className={classes.addButton} elevation={0}>
              <LinkEcco
                  external={true}
                  url={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Quiero%20realizar%20una%20consulta." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Quiero%20realizar%20una%20consulta."}
                  href={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Quiero%20realizar%20una%20consulta." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Quiero%20realizar%20una%20consulta."}
                  target="_blank"
                  onClick={()=> {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: "WAIniciaChat",
                        pageURL: window.location.href
                      },
                    })
                  }}
                >
                  <WhatsAppIcon className={classes.addButtonIcon} />
                </LinkEcco>
                
              </Fab>
          </Box>
      ):(
        <Zoom in={scrollTrigger}>
          <Box className={classes.root}>
          
              <Fab className={classes.addButton} elevation={0}>
              <LinkEcco
                  external={true}
                  url={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20los%20productos%20de%20ECCO." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20los%20productos%20de%20ECCO."}
                  href={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20los%20productos%20de%20ECCO." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20los%20productos%20de%20ECCO."}
                  target="_blank"
                  onClick={()=> {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: "WAIniciaChat",
                        pageURL: window.location.href
                      },
                    })
                  }}
                >
                  <WhatsAppIcon className={classes.addButtonIcon} />
                </LinkEcco>
                
              </Fab>
          </Box>
        </Zoom>
      )}
      
    </div>
  );
};

export default FloatingWhatsappButton;
